import { useSelector } from 'react-redux';

import { AppID, Environment } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { AvailableChannels, TeamIdWithTemplateId } from '@playq/services-teams';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';

export const teaamsChatChannelKeys: unknown[] = [
  'service',
  'lookup',
  'teams',
  'chats',
  'channels',
  'availableChannels',
];
const emptyArray: [] = [];

export const useAvailableChannels = (
  teamId: TeamIdWithTemplateId | undefined,
  env: Environment | undefined,
  options?: IUseQueryOptionsExtended<AvailableChannels | undefined, GenericFailure | Error>
) => {
  const appID: AppID | undefined = useSelector(appToolkit.selectors.appID);

  const res = useEitherQuery(
    teaamsChatChannelKeys.concat(appID, teamId, env),
    () => {
      if (
        appID !== undefined &&
        teamId !== undefined &&
        env !== undefined &&
        teamId.teamId !== undefined &&
        teamId.teamTemplateId !== undefined
      ) {
        return services2.teamsChatLookupService.availableChannels(appID, teamId, env);
      }
    },
    {
      ...options,
    }
  );

  return {
    ...res,
    channels: res.data?.channels || emptyArray,
  };
};
